module.exports = __webpack_public_path__ + "img/restaurant.a331810e.png";